import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import React from 'react';
import { IconsFactory } from '../../Utils/IconsFactory';
export class ContextMenuItem extends React.Component {
    constructor() {
        super(...arguments);
        this.ref = React.createRef();
        this.onClick = () => {
            const item = this.props.item;
            if (isValidArray(item.subitems) || item.enabled === false) {
                return;
            }
            const isCheckedItem = item.canCheck;
            if (isCheckedItem) {
                item.checked = !item.checked;
                this.forceUpdate();
            }
            if (!isNullOrUndefined(item.event)) {
                item.event(item);
            }
            if (item.closeOnClick === false) {
                return;
            }
            this.props.onCloseContextMenu();
        };
        this.onPointerEnter = () => {
            if (isValidString(this.props.item.tooltip)) {
                showTooltip(this.ref.current, Resources.getResource(this.props.item.tooltip));
            }
            const rect = this.ref.current.getBoundingClientRect();
            this.props.onMouseEnter(this.props.item, rect);
        };
        this.onPointerLeave = () => {
            if (isValidString(this.props.item.tooltip)) {
                hideTooltip();
            }
        };
    }
    render() {
        const activeStyle = this.props.item.selected ? ' _active' : '';
        const disabledStyle = this.props.item.enabled === false ? ' _disabled' : '';
        return (_jsx("div", { className: `new-context-menu-row${activeStyle}${disabledStyle}`, ref: this.ref, onClick: this.onClick, onPointerEnter: this.onPointerEnter, onPointerLeave: this.onPointerLeave, children: _jsxs("div", { className: "new-context-menu-item", children: [this.renderIcon(), _jsxs("div", { className: "new-context-menu-item-text-container", children: [_jsx("div", { className: "new-context-menu-item-text-container-text", children: this.getItemText() }), this.renderAdditionalActions()] }), this.renderSubItemsIcon(), this.renderBetaIcon()] }) }));
    }
    getItemText() {
        let text = Resources.getResource(this.props.item.text);
        if (isValidString(this.props.item.additionalText)) {
            text += ' ' + this.props.item.additionalText;
        }
        return text;
    }
    renderIcon() {
        if (!this.props.isAllowIcon) {
            return null;
        }
        const iconStyle = isValidString(this.props.item.iconStyle) ? ` ${this.props.item.iconStyle}` : '';
        const imageKey = this.props.item.canCheck && this.props.item.checked ? 'accept' : this.props.item.svgImage;
        let icon = null;
        if (isValidString(imageKey)) {
            // Ractive style (image from sprite)
            icon = (_jsx("svg", { children: _jsx("use", { xlinkHref: `assets/webdesktop/web-desktop-sprite.svg#${imageKey}` }) }));
        }
        else if (!isNullOrUndefined(this.props.item.icon)) {
            // React style (image from svg icons factory)
            icon = IconsFactory.getIconByType(this.props.item.icon, this.props.item.text);
        }
        return _jsx("div", { className: `new-context-menu-item-icon${iconStyle}`, children: icon });
    }
    renderAdditionalActions() {
        const additionalActions = this.props.item.additionalActions;
        if (!isValidArray(additionalActions)) {
            return null;
        }
        return (_jsx("div", { className: "new-context-menu-item-text-container-actions", children: additionalActions.map((action, index) => {
                return (_jsx("div", { className: "new-context-menu-item-text-container-actions-action", onClick: (event) => {
                        var _a;
                        event.stopPropagation();
                        (_a = action.event) === null || _a === void 0 ? void 0 : _a.call(action, this.props.item);
                    }, onPointerEnter: (event) => showTooltip(event.currentTarget, action.tooltip), onPointerLeave: () => hideTooltip(), children: _jsx("svg", { children: _jsx("use", { xlinkHref: `assets/webdesktop/web-desktop-sprite.svg#${action.svgImage}` }) }) }, index));
            }) }));
    }
    renderSubItemsIcon() {
        if (!this.props.isAllowSubItems) {
            return null;
        }
        return (_jsx("div", { className: "new-context-menu-item-subitems", children: isValidArray(this.props.item.subitems) && (_jsx("svg", { children: _jsx("use", { xlinkHref: "assets/webdesktop/web-desktop-sprite.svg#ArrowRight" }) })) }));
    }
    renderBetaIcon() {
        const isBeta = this.props.item.isBeta === true;
        if (!isBeta) {
            return null;
        }
        return (_jsx("div", { className: "new-context-menu-item-beta", children: _jsx("svg", { children: _jsx("use", { xlinkHref: "assets/webdesktop/web-desktop-sprite.svg#beta" }) }) }));
    }
}
